window.addEventListener('DOMContentLoaded', function() {
    console.log('------ IN ANALYTICS TRACKING EVENTS ------');

    // Main Navigation
    jQuery(".main-menu > .item > a").click(function (e) {
        localStorage.setItem("navigationPath", jQuery.trim(jQuery(this).text()));
    });

    jQuery(".main-menu .submenu_inner .link_item a").click(function (e) {
        var parentName = jQuery.trim(jQuery(this).closest('.mega-menu-trigger').find('> a').text());

        localStorage.setItem("navigationPath", parentName + " : " + jQuery.trim(jQuery(this).text()));
    });

    jQuery(".main-menu .submenu_inner .cta_btn").click(function (e) {
        var parentName = jQuery.trim(jQuery(this).closest('.mega-menu-trigger').find('> a').text());

        localStorage.setItem("navigationPath", parentName + " : " + jQuery.trim(jQuery(this).text()));
    });

    jQuery(".main-menu .submenu_inner .feat_cta_btn").click(function (e) {
        var parentName = jQuery.trim(jQuery(this).closest('.mega-menu-trigger').find('> a').text());

        localStorage.setItem("navigationPath", parentName + " : " + jQuery.trim(jQuery(this).text()));
    });

    jQuery(document).on("click", ".boost-pfs-search-suggestion-wrapper .boost-pfs-search-suggestion-item-product > a", function (e) {
        localStorage.setItem("navigationPath", "Search : " + jQuery.trim(jQuery(this).find('.boost-pfs-search-suggestion-product-title').text()));
    });

    jQuery(document).on("click", ".boost-pfs-search-suggestion-wrapper .boost-pfs-search-suggestion-item > a", function (e) {
        localStorage.setItem("navigationPath", "Search : " + jQuery.trim(jQuery(this).text()));
    });

    // Account Register
    jQuery("#create_customer").submit(function (e) {
        localStorage.setItem("registrationSubmit", Date.now());
    });

    // Account Login
    jQuery("#customer-login").submit(function (e) {
        localStorage.setItem("loginSubmit", Date.now());
    });

    // Cart Actions
    document.addEventListener('rebuy:smartcart.show', (event) => {
        if (window.rebuySmartcartIsRemoving) {
            window.rebuySmartcartIsRemoving = false;
        } else {
            const cart = event.detail.smartcart.cart;
            var products = [];

            cart.items.forEach(function (_item) {
                products.push({
                    "id": _item.product_id,
                    "handle": _item.handle,
                    "title": _item.product_title,
                    "price": _item.price,
                    "quantity": _item.quantity,
                    "vendor": _item.vendor,
                    "type": _item.product_type,
                })
            });
        }
    });

    document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
        window.rebuySmartcartIsRemoving = true;
    });



    // Checkout Button
    jQuery(document).on("click", "#rebuy-cart .rebuy-cart__flyout-actions .rebuy-button", function (e) {
        localStorage.setItem("checkoutStart", true);
    });
});